var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 12176 12176",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:360.227}\r\n    .str1 {stroke:red;stroke-width:720.475;stroke-linecap:square;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil2 {fill:#010101}\r\n    .fil1 {fill:yellow}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 12176,
    height: 12176
  }), /*#__PURE__*/React.createElement("g", {
    id: "_595338760"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M6081 1314c760,-1 939,495 1181,913l1903 3297 1906 3300c240,417 582,808 203,1466 -379,659 -898,566 -1381,566l-3807 0 -3811 0c-481,0 -990,101 -1371,-557 -381,-657 -41,-1060 200,-1478l1904 -3297 1905 -3301c241,-416 408,-907 1168,-909z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M6080 2195c170,-2 407,358 611,713l1730 2996 1722 2983c208,358 400,755 317,903 -84,149 -514,173 -923,173l-3460 0 -3444 0c-415,0 -854,-31 -941,-178 -87,-146 107,-531 312,-886l1729 -2995 1723 -2983c207,-359 454,-724 624,-726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M4659 6587l174 89c-181,426 -20,1066 -94,1292l-565 821c-107,150 -364,404 -205,640 113,168 365,222 567,-77l762 -1095c228,-334 157,-269 165,-775l710 377c11,326 0,668 0,990 0,307 -50,683 299,697 366,15 323,-366 323,-675 0,-328 -10,-672 1,-998 263,-44 290,44 671,250 73,40 584,301 641,368 -127,124 -475,251 -649,384 -134,103 -419,391 -481,590l2849 -1 -1074 -1962c-82,56 -188,190 -238,325 -56,149 -65,312 -165,415 -97,-29 -957,-520 -1131,-611 -153,-80 -122,-102 -187,-394 -71,-317 -145,-634 -217,-945 -124,-535 -70,-579 -367,-798 -400,-294 -270,-260 -894,-261 -602,-1 -548,-85 -828,328 -155,228 -324,454 -480,683 -94,141 -145,297 4,418 192,157 317,-15 409,-75zm180 -259l175 90 481 -666 -267 -3c-71,93 -360,495 -389,579zm1133 629l517 270 -167 -767c-66,51 -315,404 -350,497z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 6748,
    cy: 4970,
    r: 523
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.d651a5cb2b621ca84092a71d767f4552.svg";
export { ForwardRef as ReactComponent };